<template>
  <div
    v-if="showLoadingState"
    key="loadingState"
  >
    <AtomLoadingSecondary/>
  </div>
  <div
    v-else
    key="productPages"
  >
    <div
      v-if="productoPaginas.length > 0"
      class="align-items-baseline display-flex-row m-filters-and-actions"
    >
      <form
        autocomplete="off"
        class="align-items-baseline m-form-row"
        name="simple-filters-form"
        @submit.prevent="false"
      >
        <AtomButtonSecondary
          :button-secondary="buttonSecondary.create"
          :disabled="pagination.showLoadingState"
          @showModal="$modal.showModal"
        />
      </form>
    </div>
    <div
      v-if="productoPaginas.length > 0"
      class="m-table-primary"
    >
      <table>
        <tr>
          <th class="text-align-left">
            {{ $t('mEditionProductPagesOfGratefulness.table.thName') }}
          </th>
          <th class="text-align-center">
            {{ $t('mEditionProductPagesOfGratefulness.table.thWatch') }}
          </th>
          <th class="text-align-center">
            {{ $t('mEditionProductPagesOfGratefulness.table.thEdit') }}
          </th>
          <th class="text-align-center">
            {{ $t('mEditionProductPagesOfGratefulness.table.thPrimary') }}
          </th>
          <th class="text-align-center">
            {{ $t('mEditionProductPagesOfGratefulness.table.thDelete') }}
          </th>
        </tr>
        <tr
          v-for="pagina in productoPaginas"
          :key="pagina.id"
          class="row-data"
        >
          <td class="text-align-left">
            {{ pagina.nombre }}
            <small v-if="pagina.externo == 'externo'">
              - {{ $t('mEditionProductPagesOfGratefulness.externalSite') }}
            </small>
          </td>
          <td class="text-align-center">
            <AtomButtonIconRounded
              :button-icon-rounded="buttonIconRounded.watch"
              :element="pagina.externo === 'externo' ? pagina.url : `https://${pagina.url_preview}`"
              @openTab="openTab"
            />
          </td>
          <td class="text-align-center">
            <AtomButtonIconRounded
              v-if="pagina.externo == 'externo'"
              :key="`externalSite-${pagina.id}`"
              :button-icon-rounded="buttonIconRounded.editExternalSite"
              :element="{ 'pagina': pagina, 'productoNombre': element.nombre }"
              @showModal="$modal.showModal"
            />
            <AtomButtonIconRounded
              v-else
              :key="`page-${pagina.id}`"
              :button-icon-rounded="buttonIconRounded.editPage"
              :element="pagina"
              @createProductoPaginaIdroopActivarEdicion="createProductoPaginaIdroopActivarEdicion"
            />
          </td>
          <td class="text-align-center">
            <AtomTogglePrimary
              v-model="pagina.publicada"
              :element-id="pagina.id"
              method="updateProductoPaginaIdroopPublicar"
              name="primaria"
              sliderClass="a-toggle-slider-products-primary"
              type="radio"
              @updateProductoPaginaIdroopPublicar="updateProductoPaginaIdroopPublicar"
            />
          </td>
          <td class="text-align-center">
            <AtomButtonIconRounded
              :button-icon-rounded="buttonIconRounded.delete"
              :element="pagina"
              @showModal="$modal.showModal"
            />
          </td>
        </tr>
      </table>
      <MoleculePaginationPrimary :pagination="pagination"/>
    </div>
    <div
      v-else
    >
      <MoleculeEditionProductPagesOfGratefulnessCreateExternalSite />
    </div>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionProductPagesOfGratefulness',

  components: {
    MoleculeEditionProductPagesOfGratefulnessCreateExternalSite: () => import('@/components/molecules/MoleculeEditionProductPagesOfGratefulnessCreateExternalSite'),
    MoleculePaginationPrimary: () => import('@/components/molecules/MoleculePaginationPrimary')
  },

  props: {
    element: Object,
    elementCategorias: Array
  },

  data () {
    return {
      buttonIconRounded: {
        delete: {
          class: 'a-button-secondary a-button-danger-secondary a-button-icon-rounded a-tooltip-primary a-tooltip-bottom',
          component: 'MoleculeEditionProductPagesOfGratefulnessModalDelete',
          icon: 'far fa-trash-alt',
          method: 'showModal',
          tooltip: this.$t('mEditionProductPagesOfGratefulness.tooltip.delete'),
          type: 'button'
        },

        editExternalSite: {
          class: 'a-button-secondary a-button-products-secondary a-button-icon-rounded a-tooltip-primary a-tooltip-bottom',
          component: 'MoleculeEditionProductPagesOfGratefulnessModalEditExternalSite',
          icon: 'fas fa-pencil-alt',
          method: 'showModal',
          tooltip: this.$t('mEditionProductPagesOfGratefulness.tooltip.edit'),
          type: 'button'
        },

        editPage: {
          class: 'a-button-secondary a-button-products-secondary a-button-icon-rounded a-tooltip-primary a-tooltip-bottom',
          component: '',
          icon: 'fas fa-pencil-alt',
          method: 'createProductoPaginaIdroopActivarEdicion',
          tooltip: this.$t('mEditionProductPagesOfGratefulness.tooltip.edit'),
          type: 'button'
        },

        watch: {
          class: 'a-button-secondary a-button-products-secondary a-button-icon-rounded a-tooltip-primary a-tooltip-bottom',
          component: '',
          icon: 'far fa-file',
          method: 'openTab',
          tooltip: this.$t('mEditionProductPagesOfGratefulness.tooltip.watch'),
          type: 'button'
        }
      },

      buttonSecondary: {
        create: {
          class: 'a-button-secondary a-button-products-secondary',
          component: 'MoleculeEditionProductPagesOfGratefulnessModalCreateExternalSite',
          icon: 'fas fa-plus',
          method: 'showModal',
          text: 'Agregar Página',
          type: 'button'
        }
      },

      pagination: {
        currentPage: 1,
        currentQuantity: 0,
        limit: 10,
        showLoadingState: false,
        totalPages: 1,
        totalQuantity: 0
      },

      productoPaginas: [],
      showLoadingState: true
    }
  },

  computed: {
    updatedData () {
      return this.$modal.updatedData
    }
  },

  watch: {
    updatedData () {
      this.readProductoPaginasIdroop()
    }
  },

  created () {
    this.readProductoPaginasIdroop(true)
  },

  methods: {
    createProductoPaginaIdroopActivarEdicion (pagina) {
      this.$services.create('producto', 'createProductoPaginaIdroopActivarEdicion', {}, [pagina.id])
        .then(response => {
          window.open(response.data.url, '_blank')
        })
        .catch(error => {
          console.log(error)
          this.$alerts.pushAlert('mEditionProductPagesOfGratefulness', 'createProductoPaginaIdroopActivarEdicion', 'error', 'a-alert-danger')
        })
    },

    openTab (url) {
      if (url === 'https://undefined' || url === null) {
        this.$modal.showModal('MoleculeEditionProductPagesOfGratefulnessModalUndefined')
      } else {
        window.open(url, '_blank')
      }
    },

    readProductoPaginasIdroop (redirect) {
      this.$services.read('producto', 'readProductoPaginasIdroop', {}, [this.$route.params.id, 1])
        .then(response => {
          console.log(response.data)
          this.productoPaginas = response.data
          this.pagination.currentQuantity = this.productoPaginas.length
          this.pagination.totalQuantity = this.productoPaginas.length
          this.showLoadingState = false
        })
        .catch(error => {
          console.log(error)
        })
    },

    updateProductoPaginaIdroopPublicar (pagina) {
      this.$services.update('producto', 'updateProductoPaginaIdroopPublicar', {}, [pagina.id, pagina.state])
        .then(response => {
          console.log(response.data)
          this.$modal.updateData()
          this.$alerts.pushAlert('mEditionProductPagesOfGratefulness', 'updateProductoPaginaIdroopPublicar', response.data.primaria ? 'activationSuccess' : 'deactivationSuccess')
        })
        .catch(error => {
          console.log(error)
          this.$alerts.pushAlert('mEditionProductPagesOfGratefulness', 'updateProductoPaginaIdroopPublicar', 'error', 'a-alert-danger')
        })
    }
  }
}
</script>
